// /src/shared/components/icons/SpotifyIcon.tsx

import { FC } from 'react';
import { SiWebex } from 'react-icons/si';
import { SvgIconProps } from '@mui/material';

import BaseIcon from '../BaseIcon';

export const WebexLogo: FC<SvgIconProps> = (props) => {
  return (
    <BaseIcon
      icon={
        <SiWebex
          // react-icons does not natively support MUI props like fontSize
          // So we adapt it manually
          size={props.fontSize === 'small' ? 20 : props.fontSize === 'large' ? 36 : 24}
        />
      }
      {...props}
    />
  );
};

export default WebexLogo;
